import { ArrowRight, MessageCircle, ShieldCheck, Star } from "lucide-react";
import { whatsappUrl } from "./constants";

const HERO_IMG =
  "https://static.wixstatic.com/media/d16770_f111027e291e4f3b8212b462e0083021f000.jpg/v1/fill/w_1905,h_993,al_c,q_85,usm_0.33_1.00_0.00,enc_avif,quality_auto/d16770_f111027e291e4f3b8212b462e0083021f000.jpg";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-28 md:pt-32 pb-16 md:pb-24 overflow-hidden bg-gradient-to-b from-[#F4F8F5] via-white to-white"
    >
      <div className="absolute inset-0 dot-grid opacity-60 pointer-events-none" />

      <div className="relative max-w-[1280px] mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#E8F2EC] text-[#1F6E45] text-xs font-semibold mb-7">
              <ShieldCheck size={14} strokeWidth={2.2} />
              Biologo Nutrizionista · Dr. Christian Sacchetto
            </div>

            <h1
              data-testid="hero-headline"
              className="font-display text-[#0E1A14] text-[40px] sm:text-5xl md:text-6xl lg:text-[72px] leading-[1.02] tracking-tight"
            >
              Trasforma il fisico.
              <br />
              <span className="text-[#1F6E45]">Rivoluziona</span> la mente.
            </h1>

            <p
              data-testid="hero-subheadline"
              className="mt-7 max-w-xl text-base md:text-lg text-[#4A5A52] leading-relaxed"
            >
              Inizia il tuo percorso nella nutrizione per cambiare il fisico ma,
              soprattutto, l'approccio al cibo. Piani su misura per
              dimagrimento, ricomposizione corporea e performance sportiva.
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-4">
              <a
                href={whatsappUrl()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="hero-primary-cta"
                className="group inline-flex items-center gap-2.5 bg-[#1F6E45] text-white px-7 py-4 rounded-full font-semibold text-sm hover:bg-[#144A2E] transition-all active:scale-95 green-glow"
              >
                <MessageCircle size={17} strokeWidth={2.2} />
                Prenota la tua consulenza
                <ArrowRight size={17} className="group-hover:translate-x-1 transition-transform" />
              </a>
              <a
                href="#metodo"
                data-testid="hero-secondary-cta"
                className="inline-flex items-center gap-2 px-6 py-4 rounded-full border border-[#C9D2CC] text-[#0E1A14] text-sm font-semibold hover:border-[#1F6E45] hover:text-[#1F6E45] transition-colors"
              >
                Scopri il metodo
              </a>
            </div>

            <div className="mt-10 flex items-center gap-5">
              <div className="flex items-center gap-1.5">
                {[0, 1, 2, 3, 4].map((i) => (
                  <Star key={i} size={18} className="fill-[#F2B705] text-[#F2B705]" strokeWidth={0} />
                ))}
              </div>
              <div className="text-sm text-[#4A5A52]">
                <span className="font-bold text-[#0E1A14]">5.0 / 5</span> · Recensioni Google verificate
              </div>
            </div>
          </div>

          <div className="lg:col-span-5 relative">
            <div className="relative rounded-3xl overflow-hidden soft-shadow border border-[#E1E7E3] aspect-[4/5]">
              <img src={HERO_IMG} alt="Christian Sacchetto - Nutrizionista" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent" />
              <div className="absolute bottom-5 left-5 right-5 bg-white/95 backdrop-blur-xl rounded-2xl p-4 border border-[#E1E7E3]">
                <div className="text-[10px] uppercase tracking-[0.18em] text-[#1F6E45] font-bold mb-1">
                  In presenza & online
                </div>
                <div className="font-heading text-[#0E1A14] text-base font-bold">
                  Studio + videoconsulenza
                </div>
                <div className="text-xs text-[#6F7E76] mt-0.5">
                  350+ percorsi nutrizionali completati
                </div>
              </div>
            </div>

            {/* Floating stat */}
            <div className="absolute -left-3 md:-left-8 top-8 hidden md:block bg-white rounded-2xl px-5 py-3.5 border border-[#E1E7E3] soft-shadow">
              <div className="font-display text-2xl text-[#1F6E45]">+92%</div>
              <div className="text-[11px] uppercase tracking-[0.18em] text-[#6F7E76] font-semibold">
                Tasso aderenza
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
